import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Button,
  Box,
  Paper,
} from '@mui/material';
import { Close, Error } from '@mui/icons-material';

const PanErrorModal = ({ open, message, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{ backdropFilter: 'blur(10px)' }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
          boxShadow:
            '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        },
      }}>
      {/* Error indicator bar */}
      <Box
        sx={{
          height: 8,
          background: 'linear-gradient(90deg, #f44336 0%, #d32f2f 100%)',
        }}
      />

      {/* Header with close button */}
      <DialogTitle sx={{ position: 'relative', pb: 0 }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'grey.400',
            '&:hover': {
              backgroundColor: 'grey.100',
              color: 'grey.600',
            },
          }}>
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', pt: 0, pb: 3 }}>
        {/* Error Icon */}
        <Box
          sx={{
            mx: 'auto',
            mb: 2,
            width: 64,
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            backgroundColor: 'error.light',
            color: 'white',
          }}>
          <Error sx={{ fontSize: 60 }} />
        </Box>

        {/* Title */}
        <Typography
          variant="h5"
          component="h2"
          sx={{
            mb: 2,
            fontWeight: 'bold',
            color: 'text.primary',
            fontFamily: 'Rubik',
            fontSize:'30px'
          }}>
          Invalid PAN Number
        </Typography>

        {/* Message */}
        <Typography
          variant="body1"
          sx={{
            mb: 2,
            color: 'text.secondary',
            lineHeight: 1.6,
            fontFamily: 'Rubik',
             fontSize:'20px'
          }}>
          {message || "Your PAN number doesn't appear to be valid."}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mb: 3,
            color: 'text.secondary',
            fontFamily: 'Rubik',
             fontSize:'20px'
          }}>
          Please contact your RM and verify your registered PAN number.
        </Typography>

        {/* Action Buttons */}
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Button
            onClick={onClose}
            sx={{
              textTransform: 'none',
              backgroundColor: '#f5f5f5',
              color: 'black',
              border: '1px solid #ddd',
              '&:hover': {
                backgroundColor: '#f5f5f5',
                border: '1px solid #ddd',
              },
              fontFamily: 'Rubik',
              flex: 1,
              py: 1.5,
              fontWeight: 'medium',
              fontSize:"19px"
            }}>
            Cancel
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PanErrorModal;